"use client";
import React, { useEffect, useRef, useState } from "react";
import { Accordion, Form } from "react-bootstrap";
import {
  setCategory,
  setPriceRange,
  setItemLocation,
  setItemCondition,
  setIndustry,
  setType,
  setItemBrands,
  removeStartPrice,
  removeEndPrice,
  setItemCapacity,
} from "../../../lib/store/Slices/FilterSlice";
import { useAppDispatch, useAppSelector } from "@/lib/store/hooks";
import _ from "lodash";
import "./FilterBox.css";
import Category from "@/components/Category/Category";
import Industry from "@/components/Industry/Industry";
import Type from "@/components/TypeFilter/Type";
import FilterTag from "@/components/FilterTag/FilterTag";
import axiosClient from "../../../utils/axiosClient";
import { useRouter } from "next/router";
import { CloseOutlined } from "@ant-design/icons";
import { Checkbox, Input } from "antd";

function FilterBox(props) {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const filterState = useAppSelector((state) => state.filter);
  const formPriceRange = useRef(null);
  const checkboxesBrandsRef = useRef(null);
  const checkboxesConditionsRef = useRef(null);
  const checkboxesLocationsRef = useRef(null);
  const checkboxesCapacitiesRef = useRef(null);
  const [itemFiltersLocations, setItemFiltersLocation] = useState();

  // conditions
  const [itemConditionsData, seItemConditionsData] = useState([]);
  const [originalConditions, setOriginalConditions] = useState([]);
  const [conditionSearch, setConditionSearch] = useState("");
  const [showMoreCondition, setShowMoreCondition] = useState(false);
  const itemsToShowConditions = 5;

  // brands
  const [itemBrandsData, seItemBrandsData] = useState([]);
  const [originalBrandsData, setOriginalBrandsData] = useState([]);
  const [brandSearch, setBrandSearch] = useState("");
  const [showMoreBrands, setShowMoreBrands] = useState(false);
  const itemsToShowBrand = 5;

  // capacity
  const [itemCapacityData, seItemCapacityData] = useState([]);
  const [originalCapacityData, setOriginalCapacityData] = useState([]);
  const [capacitySearch, setCapacitySearch] = useState("");
  const [showMoreCapacity, setShowMoreCapacity] = useState(false);
  const itemsToShowCapacity = 5;

  const [checkedItems, setCheckedItems] = useState({
    all: true,
    range1: false, // $0 - $100
    range2: false, // $100 - $500
    range3: false, // $500 - $1500
    range4: false, // $1500 - $5000
    range5: false, // $5000+
  });

  useEffect(() => {
    if (router.isReady) {
      const { location, brand, condition, start_price, end_price, capacity } =
        router.query;
      if (location) {
        dispatch(setItemLocation(location));
      }

      if (brand) {
        const b = [brand];
        seItemBrandsData(b);
        dispatch(setItemBrands(brand));
      }

      if (condition) {
        const c = [condition];
        seItemConditionsData(c);
        dispatch(setItemCondition(condition));
      }

      if (capacity) {
        const cp = [capacity];
        seItemCapacityData(cp);
        dispatch(setItemCapacity(capacity));
      }

      let priceRange = {
        minPrice: start_price ? Number(start_price) : null,
        maxPrice: end_price ? Number(end_price) : null,
      };

      if (priceRange.minPrice !== null && priceRange.maxPrice !== null) {
        const rangeMapping = {
          range1: priceRange.minPrice <= 0 && priceRange.maxPrice >= 100,
          range2: priceRange.minPrice <= 100 && priceRange.maxPrice >= 500,
          range3: priceRange.minPrice <= 500 && priceRange.maxPrice >= 1500,
          range4: priceRange.minPrice <= 1500 && priceRange.maxPrice >= 5000,
          range5:
            priceRange.minPrice <= 5000 && priceRange.maxPrice === Infinity,
        };

        const allChecked = Object.values(rangeMapping).every((val) => !val);
        setCheckedItems({
          all: allChecked,
          ...rangeMapping,
        });
        dispatch(setPriceRange(priceRange));
      } else {
        setCheckedItems({
          all: true,
          range1: false, // $0 - $100
          range2: false, // $100 - $500
          range3: false, // $500 - $1500
          range4: false, // $1500 - $5000
          range5: false, // $5000+
        });
      }
    }
  }, [router.isReady, router.query]);

  useEffect(() => {
    if (props.filtersResult && props.filtersResult.locations) {
      setItemFiltersLocation(props.filtersResult.locations);
    }

    if (props.filtersResult && props.filtersResult.brandNameList) {
      setOriginalBrandsData(props.filtersResult.brandNameList);
    }

    if (props.filtersResult && props.filtersResult.conditionList) {
      setOriginalConditions(props.filtersResult.conditionList);
    }

    if (props.filtersResult && props.filtersResult.capacityList) {
      setOriginalCapacityData(props.filtersResult.capacityList);
    }

    // getFilters();
  }, [props.filtersResult]);

  useEffect(() => {
    const filteredConditions = conditionSearch
      ? originalConditions.filter((condition) =>
          condition.toLowerCase().includes(conditionSearch.toLowerCase())
        )
      : originalConditions;

    seItemConditionsData(filteredConditions);
  }, [conditionSearch, originalConditions]);

  useEffect(() => {
    const filteredBrandsList = brandSearch
      ? originalBrandsData.filter((s) =>
          s.toLowerCase().includes(brandSearch.toLowerCase())
        )
      : originalBrandsData;

    seItemBrandsData(filteredBrandsList);
  }, [brandSearch, originalBrandsData]);

  // originalCapacityData
  useEffect(() => {
    const filteredList = capacitySearch
      ? originalCapacityData.filter((s) =>
          s.toLowerCase().includes(capacitySearch.toLowerCase())
        )
      : originalCapacityData;

    seItemCapacityData(filteredList);
  }, [capacitySearch, originalCapacityData]);

  function initialEmptyData() {
    setOriginalConditions([]);
    setOriginalBrandsData([]);
  }

  const getFilters = async () => {
    try {
      const res = await axiosClient.get("GetItemsFilters");

      if (res) {
        setOriginalConditions(res.conditionList);
        setOriginalBrandsData(res.brandNameList);
        setItemFiltersLocation(res);
      } else {
        initialEmptyData();
      }
    } catch (error) {
      initialEmptyData();
    }
  };
  const clickIndustry = (item) => {
    dispatch(setIndustry(item));
  };
  const clickCategory = (item) => {
    dispatch(setCategory(item));
  };

  const clickType = (item) => {
    dispatch(setType(item));
  };

  const handleLocationChange = () => {
    const checkcondtionboxes = checkboxesLocationsRef.current.querySelectorAll(
      'input[type="checkbox"]'
    );

    const locations = Array.from(checkcondtionboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    dispatch(setItemLocation(locations));
    window.scrollTo(0, 0);
  };

  const handleConditionToggle = (val) => {
    const checkcondtionboxes = checkboxesConditionsRef.current.querySelectorAll(
      'input[type="checkbox"]'
    );
    const selectedBrandList = Array.from(checkcondtionboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    if (val.target.value) {
      setConditionSearch(val.target.value);
    } else {
      setConditionSearch("");
    }

    dispatch(setItemCondition(selectedBrandList));
    window.scrollTo(0, 0);
  };

  const handleChangeCondition = () => {
    const checkcondtionboxes = checkboxesConditionsRef.current.querySelectorAll(
      'input[type="checkbox"]'
    );
    const selectedBrandList = Array.from(checkcondtionboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    dispatch(setItemCondition(selectedBrandList));
    window.scrollTo(0, 0);
  };

  const handleToggleBrand = (val) => {
    const checkboxes = checkboxesBrandsRef.current.querySelectorAll(
      'input[type="checkbox"]'
    );
    const selectedBrandList = Array.from(checkboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    if (val.target.value) {
      setBrandSearch(val.target.value);
    } else {
      setBrandSearch("");
    }
    dispatch(setItemBrands(selectedBrandList));
    window.scrollTo(0, 0);
  };

  const handleChangeBrand = () => {
    const checkboxes = checkboxesBrandsRef.current.querySelectorAll(
      'input[type="checkbox"]'
    );
    const selectedBrandList = Array.from(checkboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    dispatch(setItemBrands(selectedBrandList));
  };

  const handleCapacityToggle = (val) => {
    const checkboxes = checkboxesCapacitiesRef.current.querySelectorAll(
      'input[type="checkbox"]'
    );
    const selectedCapacityList = Array.from(checkboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    if (val.target.value) {
      setCapacitySearch(val.target.value);
    } else {
      setCapacitySearch("");
    }
    dispatch(setItemCapacity(selectedCapacityList));
    window.scrollTo(0, 0);
  };

  const handleChangeCapacity = () => {
    const checkboxes = checkboxesCapacitiesRef.current.querySelectorAll(
      'input[type="checkbox"]'
    );
    const selectedCapacityList = Array.from(checkboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    dispatch(setItemCapacity(selectedCapacityList));
  };
  const resetIndustryFilter = () => {
    dispatch(setIndustry({ id: 0, name: "", slugName: "" }));
  };
  const resetCategoryFilter = () => {
    dispatch(setCategory({ id: 0, name: "", slugName: "" }));
  };

  const resetTypeFilter = () => {
    dispatch(setType({ id: 0, name: "", slugName: "" }));
  };

  const handleShowMoreToggle = () => {
    setShowMoreCondition(!showMoreCondition); // Toggle the showMore state
  };

  const handleShowMoreBrandsToggle = () => {
    setShowMoreBrands(!showMoreBrands); // Toggle the showMore state
  };

  const handleShowMoreCapacityToggle = () => {
    setShowMoreCapacity(!showMoreCapacity); // Toggle the showMore state
  };

  const handlePriceRangeChange = (event) => {
    const { name, checked } = event.target;

    // Update the checked state
    setCheckedItems((prev) => {
      const updatedCheckedItems = { ...prev, [name]: checked };

      // If any range is checked, uncheck "All"
      if (name !== "all" && checked) {
        updatedCheckedItems.all = false;
      }

      // If "All" is checked, uncheck all ranges
      if (name === "all" && checked) {
        return {
          all: true,
          range1: false,
          range2: false,
          range3: false,
          range4: false,
          range5: false,
        };
      }

      // Determine min and max prices based on selected ranges
      const selectedRanges = [];

      if (updatedCheckedItems.range1) selectedRanges.push({ min: 0, max: 100 });
      if (updatedCheckedItems.range2)
        selectedRanges.push({ min: 100, max: 500 });
      if (updatedCheckedItems.range3)
        selectedRanges.push({ min: 500, max: 1500 });
      if (updatedCheckedItems.range4)
        selectedRanges.push({ min: 1500, max: 5000 });
      if (updatedCheckedItems.range5)
        selectedRanges.push({ min: 5000, max: Infinity });

      if (selectedRanges.length > 0) {
        const minPrice = Math.min(...selectedRanges.map((range) => range.min));
        const maxPrice = Math.max(...selectedRanges.map((range) => range.max));
        var priceRangeData = {
          minPrice: Number(minPrice),
          maxPrice: Number(maxPrice),
        };

        dispatch(setPriceRange(priceRangeData));
      } else {
        dispatch(removeStartPrice());
        dispatch(removeEndPrice());
      }

      window.scrollTo(0, 0);
      return updatedCheckedItems;
    });
  };

  const clearConditionSearch = () => {
    setConditionSearch("");
    seItemConditionsData(originalConditions);
  };

  const clearCapacitySearch = () => {
    setCapacitySearch("");
    seItemCapacityData(originalConditions);
  };

  const clearBrandSearch = () => {
    setBrandSearch("");
    seItemBrandsData(originalBrandsData);
  };
  return (
    <>
      <div className="filter-box-container">
        <FilterTag />
        <div className="filter-box-container">
          <div className="clearfilterflex">
            <p style={{ fontWeight: 600 }}>All Industry </p>
          </div>
          <div className="overflowfilters">
            <Industry resetIndustryFilter={resetIndustryFilter} />
          </div>
        </div>
        <div className="filter-box-container">
          <p style={{ fontWeight: 600 }}>All Categories</p>
          <div className="overflowfilters">
            <Category resetCategoryFilter={resetCategoryFilter} />
          </div>
        </div>
        <div className="filter-box-container">
          <p style={{ fontWeight: 600 }}>All Types</p>
          <div className="overflowfilters">
            <Type resetTypeFilter={resetTypeFilter} />
          </div>
        </div>

        {/* New Selectort Filter Ends here */}
        <Accordion
          className="filter-accordion"
          defaultActiveKey={["0", "1", "2", "6", "3", "4", "5"]}
          alwaysOpen
        >
          <Accordion.Item eventKey="6">
            <Accordion.Header>Item Location</Accordion.Header>
            <Accordion.Body>
              <div ref={checkboxesLocationsRef}>
                <ul className="filter-list-item">
                  {itemFiltersLocations &&
                    itemFiltersLocations.map((locationItem, index) => (
                      <li key={index}>
                        <Checkbox
                          name={locationItem}
                          value={locationItem}
                          id={locationItem}
                          checked={filterState?.locations?.includes(
                            locationItem
                          )}
                          onChange={handleLocationChange}
                        >
                          <span className="checkboxText">{locationItem}</span>
                        </Checkbox>
                      </li>
                    ))}
                </ul>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>Price</Accordion.Header>
            <Accordion.Body>
              <form ref={formPriceRange}>
                <div className="price-list">
                  <div className="price-list-wrap">
                    <ul className="filter-list-item">
                      <li>
                        <Checkbox
                          name="all"
                          checked={checkedItems.all}
                          onChange={handlePriceRangeChange}
                        >
                          <span className="checkboxText">All</span>
                        </Checkbox>
                      </li>
                      <li>
                        <Checkbox
                          name="range1"
                          checked={checkedItems.range1}
                          onChange={handlePriceRangeChange}
                        >
                          <span className="checkboxText">$0 - $100</span>
                        </Checkbox>
                      </li>
                      <li>
                        <Checkbox
                          name="range2"
                          checked={checkedItems.range2}
                          onChange={handlePriceRangeChange}
                        >
                          <span className="checkboxText">$100 - $500</span>
                        </Checkbox>
                      </li>
                      <li>
                        <Checkbox
                          name="range3"
                          checked={checkedItems.range3}
                          onChange={handlePriceRangeChange}
                        >
                          <span className="checkboxText">$500 - $1500</span>
                        </Checkbox>
                      </li>
                      <li>
                        <Checkbox
                          name="range4"
                          checked={checkedItems.range4}
                          onChange={handlePriceRangeChange}
                        >
                          <span className="checkboxText">$1500 - $5000</span>
                        </Checkbox>
                      </li>
                      <li>
                        <Checkbox
                          name="range5"
                          checked={checkedItems.range5}
                          onChange={handlePriceRangeChange}
                        >
                          <span className="checkboxText">$5000+</span>
                        </Checkbox>
                      </li>
                    </ul>
                  </div>
                </div>
              </form>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>Brand</Accordion.Header>
            <Accordion.Body>
              <div ref={checkboxesBrandsRef}>
                <div>
                  <div className="input-group position-relative">
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Search Brands"
                      aria-label="Search"
                      aria-describedby="search-icon"
                      value={brandSearch}
                      onChange={handleToggleBrand}
                      // Handle search input changes
                    />
                    {/* Display the cross icon to clear the search input */}
                    {brandSearch && (
                      <span className="clear-search" onClick={clearBrandSearch}>
                        &#x2715; {/* Cross icon */}
                      </span>
                    )}
                  </div>

                  <ul className="filter-list-item">
                    {itemBrandsData &&
                      itemBrandsData
                        .slice(
                          0,
                          showMoreBrands
                            ? itemBrandsData.length
                            : itemsToShowBrand
                        )
                        .map((brand, index) => (
                          <li key={index}>
                            <Checkbox
                              name={brand}
                              value={brand}
                              defaultChecked={filterState.brandNameList.includes(
                                brand
                              )}
                              id={brand}
                              onChange={handleChangeBrand}
                            >
                              <span className="checkboxText">{brand}</span>
                            </Checkbox>
                          </li>
                        ))}
                  </ul>

                  {/* Show More/Show Less Button */}
                  {itemBrandsData.length > itemsToShowBrand && (
                    <button
                      onClick={handleShowMoreBrandsToggle}
                      className="show-more-btn"
                    >
                      {itemsToShowBrand ? "Show Less" : "Show More"}
                    </button>
                  )}
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5">
            <Accordion.Header>Condition</Accordion.Header>
            <Accordion.Body>
              <div ref={checkboxesConditionsRef}>
                <div>
                  <div className="input-group position-relative">
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Search condition"
                      aria-label="Search"
                      aria-describedby="search-icon"
                      value={conditionSearch}
                      onChange={handleConditionToggle}
                      // Handle search input changes
                    />
                    {/* Display the cross icon to clear the search input */}
                    {conditionSearch && (
                      <span
                        className="clear-search"
                        onClick={clearConditionSearch}
                      >
                        &#x2715; {/* Cross icon */}
                      </span>
                    )}
                  </div>

                  <ul className="filter-list-item">
                    {itemConditionsData &&
                      itemConditionsData
                        .slice(
                          0,
                          showMoreCondition
                            ? itemConditionsData.length
                            : itemsToShowConditions
                        )
                        .map((condition, index) => (
                          <li key={index} className="condition-list">
                            <Checkbox
                              name={condition}
                              value={condition}
                              defaultChecked={filterState.conditionList.includes(
                                condition
                              )}
                              id={condition}
                              onChange={handleChangeCondition}
                            >
                              <span className="checkboxText">{condition}</span>
                            </Checkbox>
                          </li>
                        ))}
                  </ul>

                  {/* Show More/Show Less Button */}
                  {itemConditionsData.length > itemsToShowConditions && (
                    <button
                      onClick={handleShowMoreToggle}
                      className="show-more-btn"
                    >
                      {showMoreCondition ? "Show Less" : "Show More"}
                    </button>
                  )}
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6">
            <Accordion.Header>Capacity</Accordion.Header>
            <Accordion.Body>
              <div ref={checkboxesCapacitiesRef}>
                <div>
                  <div className="input-group position-relative">
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Search capacity"
                      aria-label="Search"
                      aria-describedby="search-icon"
                      value={capacitySearch}
                      onChange={handleCapacityToggle}
                      // Handle search input changes
                    />
                    {/* Display the cross icon to clear the search input */}
                    {capacitySearch && (
                      <span
                        className="clear-search"
                        onClick={clearCapacitySearch}
                      >
                        &#x2715; {/* Cross icon */}
                      </span>
                    )}
                  </div>

                  <ul className="filter-list-item">
                    {itemCapacityData &&
                      itemCapacityData
                        .slice(
                          0,
                          showMoreCapacity
                            ? showMoreCapacity.length
                            : itemsToShowCapacity
                        )
                        .map((capacity, index) => (
                          <li key={index} className="condition-list">
                            <Checkbox
                              name={capacity}
                              value={capacity}
                              defaultChecked={filterState?.capacities?.includes(
                                capacity
                              )}
                              id={capacity}
                              onChange={handleChangeCapacity}
                            >
                              <span className="checkboxText">{capacity}</span>
                            </Checkbox>
                          </li>
                        ))}
                  </ul>

                  {/* Show More/Show Less Button */}
                  {itemCapacityData.length > itemsToShowCapacity && (
                    <button
                      onClick={handleShowMoreCapacityToggle}
                      className="show-more-btn"
                    >
                      {showMoreCapacity ? "Show Less" : "Show More"}
                    </button>
                  )}
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  );
}

export default FilterBox;
